import React, { useEffect } from "react";
import useIframeCommunicator from "../../hooks/useIframeCommunicator";
import { useSearchParams, useLocation, useParams } from "react-router-dom";

const IframeCommunicator = () => {
  const query = useSearchParams();
  const location = useLocation();
  const params = useParams();

  const [message, sendMessage] = useIframeCommunicator("*");
  useEffect(() => {
    if (message) {
      // Handle the message received from the iframe
      console.log("Received message:", message);
    }
  }, [message]);
  useEffect(() => {
    console.log("Received message:", query);
    const queryObj = Object.fromEntries(query.entries());
    sendMessage({
      query: queryObj,
      path: location.pathname,
      params,
      location,
    });
  }, [query, location, params]);

  return (
    <div>
      <h2>Completed</h2>
    </div>
  );
};

export default IframeCommunicator;
